import './polyfills/reactDomLegacy';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import './index.css';
import './responsive.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { store } from './store';

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
registerServiceWorker();
